// Version information - automatically updated on build
export const APP_VERSION = "0.1.0";
export const BUILD_NUMBER = "1304";
export const BUILD_DATE = new Date().toISOString();

// Helper function to get full version string
export const getFullVersion = () => {
  return `${APP_VERSION}.${BUILD_NUMBER}`;
};

// Helper function to get build info
export const getBuildInfo = () => {
  return {
    version: APP_VERSION,
    buildNumber: BUILD_NUMBER,
    buildDate: BUILD_DATE,
    fullVersion: getFullVersion()
  };
};
